/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { LoginPayload, LoginResponse } from './types';
import { apiClient } from '@/utils/apiClient';

export const postLogin = createAsyncThunk<
  LoginResponse,
  LoginPayload,
  { rejectValue: string }
>('login/postLogin', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/login//', {
      method: 'POST',
      body: payload,
    });
    return response as LoginResponse;
  } catch (err: any) {
    const res: any = err?.response ?? err;

    const msg =
      (Array.isArray(res?.error) && res.error.join(' ')) ||
      res?.error ||
      res?.message ||
      'Login failed';

    return rejectWithValue(String(msg));
  }
});
